// export const loadRazorpay = () => {
//   return new Promise((resolve) => {
//     const script = document.createElement('script');
//     script.src = 'https://checkout.razorpay.com/v1/checkout.js';
//     script.async = true;
//     script.onload = () => {
//       resolve();
//     };
//     document.body.appendChild(script);
//   });
// };

export const loadRazorpay = () => {
	return new Promise((resolve) => {
		const scriptExists = document.querySelector(
			'script[src="https://checkout.razorpay.com/v1/checkout.js"]',
		);
		if (scriptExists) {
			resolve(true);
			return;
		}

		const script = document.createElement("script");
		script.src = "https://checkout.razorpay.com/v1/checkout.js";
		script.onload = () => resolve(true);
		script.onerror = () => resolve(false);
		document.body.appendChild(script);
	});
};

// Then in your handleRazorpayPayment function, replace:
// await loadRazorpay();
// with:
// await loadRazorpayScript();
